import { type DaasMarketplaceCollection } from '@app/client';
export const mocData: DaasMarketplaceCollection[] = [
    {
        daas_id: '102973',
        metadata: {
            name: 'Azuki',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/HTfDnsQfaqpkdPB0OITH5RSoAHKTUDYsB03S2jaClYMbnhhoTIB7u4Ln8QU01OvkJky1Tm1s6DsQtZMDqZcZ-zpy9lizOahrHA',
            description:
                'Take the red bean to join the garden. View the collection at [azuki.com/gallery](https://azuki.com/gallery).\r\n\r\nAzuki starts with a collection of 10,000 avatars that give you membership access to The Garden: a corner of the internet where artists, builders, and web3 enthusiasts meet to create a decentralized future. Azuki holders receive access to exclusive drops, experiences, and more. Visit [azuki.com](https://azuki.com) for more details.\r\n\r\nWe rise together. We build together. We grow together.',
            external_url: 'http://www.azuki.com',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/xXglLI2d2Un6Qb7-vwtb33LvWs5Oj4Yg1jQ3BBFgHM_8_iuzb--s4qj9Qcgmm0EgnLDgP6lmy81XA2nK3qFmseNaObO_8GquUMI=w2500',
        },
        slug: 'azuki',
        floor_price_wei: '4337000000000000000',
        reservoir_id: '0xed5af388653567af2f388e6224dc7c4b3241c544',
        spam_score: 0,
    },
    {
        daas_id: '99889',
        metadata: {
            name: 'BEANZ Official',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/I4wgF3m9pLIn-MwO19gcAvECu4vNMuhZk8wkr61Lux5e2cX5M6I55T4u6Ez4-rniLny4dOBL2L09H-lt6Dh9AGSg0mC5hF_Lm3Y',
            description:
                "BEANZ are a small species that sprouts from the dirt in the garden. They make for a great sidekick to an Azuki, although some like to kick it alone. They're earnestly driven by the desire to help. However, certain BEANZ feel a calling to pave their own path...",
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/7Io0gOh7TFirbZ-vDVO4Jrw7aYxe3y1exQZaydXFOh6ED8d_7MTF-OOjz2tjl1fe2ZDCWui73rKEQImlqp5CBXbpp4hyC7OEPYc=w2500',
        },
        slug: 'beanzofficial',
        floor_price_wei: '253000000000000000',
        reservoir_id: '0x306b1ea3ecdf94ab739f1910bbda052ed4a9f949',
        spam_score: 0,
    },
    {
        daas_id: '93314',
        metadata: {
            name: 'Bored Ape Kennel Club',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/9C9KKwWh9np4FtSlKoE4WWS6GjXpE8eSZ5LH_UV_qAE09Mrsn9O-fCSJcgE7r9XtBdf7ArCM6tgO0V4eHG9fVWQ5Z2fqCDMZDcI',
            description:
                "It gets lonely in the swamp sometimes. That's why every ape should have a four-legged companion. To curl up at your feet. To bring you a beer. To fire a missile launcher at that bastard Jimmy the Monkey.\r\n\r\nThat's why we've started the Bored Ape Kennel Club, and why we're offering up a dog NFT for adoption to every single member of the BAYC – for free (you only pay gas).\r\n\r\nLearn more at: http://boredapeyachtclub.com/#/kennel-club",
            external_url: 'http://boredapeyachtclub.com/#/kennel-club',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/49WD79WFli3U7x4qSDoVmiTk1lR7hTKBikBwtO4V05EkStkpqh1B-vxyDxyDvzLCOuuEDQypbWHILkwNggmh7j-q94aP9xmgs9ec=w2500',
        },
        slug: 'bored-ape-kennel-club',
        floor_price_wei: '1839000000000000000',
        reservoir_id: '0xba30e5f9bb24caa003e9f2f0497ad287fdf95623',
        spam_score: 0,
    },
    {
        daas_id: '101776',
        metadata: {
            name: 'Bored Ape Yacht Club',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/C_fjl1iM5iRwuk74N9DBrOmU-1-_lc_8x66BsWU8votTb3iwXiVJwmqJ2qd8BUI1DSDo_9KxcNcNJrdpnnxebLwpeJB7eiYSeI8',
            description:
                'The Bored Ape Yacht Club is a collection of 10,000 unique Bored Ape NFTs— unique digital collectibles living on the Ethereum blockchain. Your Bored Ape doubles as your Yacht Club membership card, and grants access to members-only benefits, the first of which is access to THE BATHROOM, a collaborative graffiti board. Future areas and perks can be unlocked by the community through roadmap activation. Visit www.BoredApeYachtClub.com for more details.',
            external_url: 'http://www.boredapeyachtclub.com/',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/rtq1n9yu0o2EPKilnOiBj7ytu2NNdxUiu8czjEj4R7WJid3OTXQAS9oEXCgVrdj3frEj296C-p2tlyBKMhWtussdImr_jsaFCV0=w2500',
        },
        slug: 'boredapeyachtclub',
        floor_price_wei: '26280000000000000000',
        reservoir_id: '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
        spam_score: 0,
    },
    {
        daas_id: '102992',
        metadata: {
            name: 'CLONE X - X TAKASHI MURAKAMI',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/21TYFeoq3hTDKWUJhtIXthkyaLr2WzU9s9U9-n6VRt2xpCxFZkNQDVegbAknE0ZwrIQj0VwcPa3ci5jBrqxmM9HQ-9mDJlFJVKF9',
            description: '🧬 CLONE X 🧬\r\n\r\n20,000 next-gen Avatars, by RTFKT and Takashi Murakami 🌸',
            external_url: 'http://www.rtfkt.com',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/HPcdpQ3_Md4UE9uGCNJEn8XNm9S_HXTO0E_-8monLzRClg7Wo1roEg4MZcxb-8nw29ri7ErLlRLH86CBvzAjydbQMNqDcYLK-_k=w2500',
        },
        slug: 'clonex',
        floor_price_wei: '1349900000000000000',
        reservoir_id: '0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b',
        spam_score: 0,
    },
    {
        daas_id: '96729',
        metadata: {
            name: 'Cool Cats NFT',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/pCMTlkfx-5Oxf_Cl0vK5xMh8tshXbBBRB36KpLODcJSqtHmdR3hf4Gfx8RMQoDIQIPTv3xbtNtxA6w9wSeKwtmZVeJwjoFG63d0V',
            description:
                'Cool Cats is a collection of 9,999 randomly generated and stylistically curated NFTs that exist on the Ethereum Blockchain. Cool Cat holders can participate in exclusive events such as NFT claims, raffles, community giveaways, and more. Remember, all cats are cool, but some are cooler than others.\r\n\r\n- [Cool Cats Collabs](https://opensea.io/collection/cool-cats-collabs)\r\n- [Cool Cats Events](https://opensea.io/collection/cool-cats-events)\r\n- [Cool Cats Achievements](https://opensea.io/collection/cool-cats-achievements)\r\n- [Cool Cats Originals](https://opensea.io/collection/cool-cats-originals)',
            external_url: 'http://coolcatsnft.com',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/36McUC0QOKkTkj6IwHh3SvPrYD-PNA3ukYNYiBwj_i3YvSDWn5hn2VDqPwCWkbXlrZTiMuFLPQOMfmxemv5VACRQjoMS_BFWT04=w2500',
        },
        slug: 'cool-cats-nft',
        floor_price_wei: '588800000000000000',
        reservoir_id: '0x1a92f7381b9f03921564a437210bb9396471050c',
        spam_score: 0,
    },
    {
        daas_id: '109060',
        metadata: {
            name: 'Cool Pets NFT',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/cftcUDVUyLAsFFCa-EylkCaSDvLQ1zeRdC5e8uguCQhacdMhgL_Tp-VlSKMSdl66hTtIpN1C_BjtyMpyauFvOmA_rAWxdo5-dbIp',
            description:
                'An NFT offering from the Cool Cats brand, Pets is a collection of 19,999 NFTs that are procedurally generated based on item interaction. All Pets start as an Egg and evolve into their final form, which represents one of four elements: Grass, Fire, Water, or Air. Users can evolve their Pet through our gamified experience on [coolcatsnft.com](https://coolcatsnft.com)–your final Pet is one of 17 million possible outcomes! To learn more about Pets, Eggs, and the world of Cooltopia, visit [cooltopia.coolcatsnft.com](https://cooltopia.coolcatsnft.com). We love the Pets!',
            external_url: 'http://coolcatsnft.com',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/kWFuo31b7rkfIAWT3I-VrpEyda9HxndgEEEaLYPHHfxENmcriqVR-CVVKOYtmivAXSnIKNCBL-kriIyHFsxBhIL_wT-nz61jwQ=w2500',
        },
        slug: 'coolpetsnft',
        floor_price_wei: '30900000000000000',
        reservoir_id: '0x86c10d10eca1fca9daf87a279abccabe0063f247',
        spam_score: 0,
    },
    {
        daas_id: '75516',
        metadata: {
            name: 'CrypToadz by GREMPLIN',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/2j1NBEHyFiXYvB34EuWlE5Dn1tU9P6HJUCLVvJAfuJjW6A3fq-zLLmP3q2IWUMhpgXJSAT3rPEZvvQYB5o7WRD3ySN6A6Gj6kbE',
            description:
                'CrypToadz are a collection 6969 small amphibious creatures trying to escape the tyrannical rule of the Evil King Gremplin. Created by Gremplin, with a small bit of help from his friends.\r\n\r\nThis project is in the public domain. Feel free to use the toadz in any way you want.',
            external_url: 'https://cryptoadz.io',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/d0NVSC_pO8LYP7JzFHMfsadcapt2OUv-4m2_QDK0w3hhURTXcbgbvpl-mhKEyckq9ybz2-yT4VCMdC00u-yQKDaEoxZMsVeBLbCj=w2500',
        },
        slug: 'cryptoadz-by-gremplin',
        floor_price_wei: '676100000000000000',
        reservoir_id: '0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6',
        spam_score: 0,
    },
    {
        daas_id: '104901',
        metadata: {
            name: 'Doodles',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/lHh9kLpq9hcoAgg_lEcyTCMiXvadRxY-rpKefJf_P_c5-0qybTFe5HDJ-XfcNai_fR2xE4B1Z89RnVK-AumizAgNXXfZrMxP-qQ',
            description:
                'A community-driven collectibles project featuring art by Burnt Toast. Doodles come in a joyful range of colors, traits and sizes with a collection size of 10,000. Each Doodle allows its owner to vote for experiences and activations paid for by the Doodles Community Treasury.',
            external_url: 'https://doodles.app',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/aKWruw0wbBaZ0InwuXuQ7Ypgr5dT_d72y8_WaffNgQedJrIK4BrpNMQV5d7CHZEk6xLI29T04k-whQ2ziLsbOpcZC8CPOtWDKQ=w2500',
        },
        slug: 'doodles-official',
        floor_price_wei: '1269990000000000000',
        reservoir_id: '0x8a90cab2b38dba80c64b7734e58ee1db38b8992e',
        spam_score: 0,
    },
    {
        daas_id: '104980',
        metadata: {
            name: 'Meebits',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/7k-VzpwMCpsXjS_s5T1qqVVNyVwopAKXYiFwSyEZPp694EXgizXj1JXHQ-RDdcd8jMwR143VCSeVfbRvAKWBxtiysEWF-_gqAA',
            description:
                'The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/OtwC7h836B3hN4BgxCcGlfzjJiNeYzfC38WaGaqDmmPynHj9Ap7n0c8cRUSU_sjDXmvq_Ln8A4V7NuwYcayDN7c_bsNsBjcIuQ=w2500',
        },
        slug: 'meebits',
        floor_price_wei: '1111710000000000000',
        reservoir_id: '0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7',
        spam_score: 0,
    },
    {
        daas_id: '105822',
        metadata: {
            name: 'Mutant Ape Yacht Club',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/z33Y-z7aURg8ZLwuukYoKmeC7zQW4suCNEljTK27tqdy632Yd3AHMuA5KZauhadoQJITR0YMsnnx517feAstoGc3kIuM14Jo2A',
            description:
                'The MUTANT APE YACHT CLUB is a collection of up to 20,000 Mutant Apes that can only be created by exposing an existing Bored Ape to a vial of MUTANT SERUM or by minting a Mutant Ape in the public sale.',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/fnlWinkrVjCyeBsx6sOj3WoxcVX3-_dM98ksclNY_z0BJ1EFOPVhGqwLbrber4wepQZVzmIrJ2Jrwy9qrfOAo25xXS07lW3zYg=w2500',
        },
        slug: 'mutant-ape-yacht-club',
        floor_price_wei: '5190000000000000000',
        reservoir_id: '0x60e4d786628fea6478f785a6d7e704777c86a7c6',
        spam_score: 0,
    },
    {
        daas_id: '104408',
        metadata: {
            name: 'Nakamigos',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/adpVfc0lqPGQ5li632eVWq1tMbok4ZQz9rcH1e1LBn1gh5zo2f39qF9B2S_rO72G1AJdNU2OgDcb_lQYOfv_IPGhACMC03zVwA',
            description:
                '20,000 unique crypto investors on the blockchain with commercial rights. Twitter: [@Nakamigos](https://twitter.com/Nakamigos).',
            external_url: 'https://nakamigos.io/',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/g5c66ZwBMGXurdQMy3ti7SShZbdzaR4vmUU89krY5wTNpWVZTJRxnZFuoKnUVUNDVs5-BQ1AtwC_Yy1xs1Gk-uSsTrsgwQhS94yd=w2500',
        },
        slug: 'nakamigos',
        floor_price_wei: '337500000000000000',
        reservoir_id: '0xd774557b647330c91bf44cfeab205095f7e6c367',
        spam_score: 0,
    },
    {
        daas_id: '105781',
        metadata: {
            name: 'Otherdeed for Otherside',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/WL2w--5nOFdHr9YSajOYQ2nI2Xrb_8Dk2rjKjvudNjyNaZ3COvThFzJHhYds56wlVz90SN-rw04lmeLMzOHueAu7qikiab_EqIc',
            description:
                'Otherdeed is the key to claiming land in Otherside. Each have a unique blend of environment and sediment — some with resources, some home to powerful artifacts. And on a very few, a Koda roams.',
            external_url: 'https://otherside.xyz',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/SV_0fdLquhCFbt-n5pbg-oXUuKJlmyZUqwpQncRWnuOApd88AF312fS2NlgJF0Z3q-jUk929AHZh3QsOi9_e1bvIQpJ90DIUWUk=w2500',
        },
        slug: 'otherdeed',
        floor_price_wei: '588800000000000000',
        reservoir_id: '0x34d85c9cdeb23fa97cb08333b511ac86e1c4e258',
        spam_score: 0,
    },
    {
        daas_id: '104038',
        metadata: {
            name: 'Moonbirds',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/CepIQormBUzDiqwCqJizJZN3vsEXlQvzomNS4fTWvN_FYfdfpXieSMZ1XeLnOy0V1LRZiMuUF8iW8nVAZvXDOvk44RXHOMaolEE',
            description:
                'Moonbirds is the art collector’s PFP. Each of the 10,000 digital artworks in the collection grants holders access to unique experiences to connect with artists and own and champion their art. As a community, Moonbirds is a home for creatives, dreamers, and collectors seeking real connection as we all contribute to the future of web3 art, culture, and technology.\n\nMoonbird art is entirely in-chain, meaning the images are outputted directly from the smart contract, with no need for storage on IPFS or the like. There are also a number of customisable backgrounds available to holders based on their on-chain activity (such as other NFT holdings)—which disappear when the bird is transferred. You can check what each bird looks like with the different backgrounds (and see if they have any unclaimed rewards!) on our [site](https://proof.xyz/moonbirds)',
            external_url: 'https://proof.xyz/moonbirds',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/Z1_yazoJ26Q75zpvvlIYJMe6ZaibkWgBWAYShmGNm7wvIDf_bi_00Qc6FdiFCKeApOeUg4zz-tCVPNqg_D4Yz-BmGwrLIes8jRQ=w2500',
        },
        slug: 'proof-moonbirds',
        floor_price_wei: '1247600000000000000',
        reservoir_id: '0x23581767a106ae21c074b2276d25e5c3e136a68b',
        spam_score: 0,
    },
    {
        daas_id: '103806',
        metadata: {
            name: 'Pudgy Penguins',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/TbbppD5KJwxtyLaGM4dtCnLtMlwslnP2Tf1YJxQFSZqGwwmxTbZB_aIvp0mcIdd4UJg5O7W2PjXCoJ4DT7wKP3S_cbhb2JXGLTFb',
            description:
                'Pudgy Penguins is a collection of 8,888 NFT’s, accelerating Web3 innovation through IP utilization and community empowerment. Embodying love, empathy, & compassion, the Pudgy Penguins are a beacon of good vibes & positivity for everyone. Each holder receives exclusive access to experiences, events, IP licensing opportunities and more. Let’s break through the boundaries of Web3 together.\r\n\r\nPudgy Collections:\r\n[Lil Pudgys](https://opensea.io/collection/lilpudgys) | [Pudgy Rods](https://opensea.io/collection/pudgyrods)',
            external_url: 'https://www.pudgypenguins.com/',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/R9ax5RogrLUsbOQWjOaZY2qjvZCEVfOmJTubo25x_q2smWyxkmztLQe3_-XLkA8XE7VYpRD-afI8jzoYuYGppELi8k7IbkBGin4=w2500',
        },
        slug: 'pudgypenguins',
        floor_price_wei: '4045450000000000000',
        reservoir_id: '0xbd3531da5cf5857e7cfaa92426877b022e612cf8',
        spam_score: 0,
    },
    {
        daas_id: '104859',
        metadata: {
            name: 'RENGA',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/H771zwRIb_z5iMaQ-yyW-ligS9kbIaRmFS6EePMtKnR35_MQobjdQm4CsK0H1z1OYkuGtqYP3GrGs4IL6xebTYMp5w6bFoUrt9A',
            description:
                'A handcrafted collection of 10,000 characters developed by artist DirtyRobot. Each with their own identity to be discovered within the wider stories of RENGA. In its purest form, RENGA is the art of storytelling.',
            external_url: 'https://renga.app/',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/Lg7SrGr1mQAfDnHaS7dLndkpiwBk1BX3b3Ha1VCkZhUMD__YHiZ3YJ8sVAyVQEDkFzs3PjEoNuBuFlNZaW2QkfZDmvIaN-B8XqTt=w2500',
        },
        slug: 'renga',
        floor_price_wei: '211900000000000000',
        reservoir_id: '0x394e3d3044fc89fcdd966d3cb35ac0b32b0cda91',
        spam_score: 0,
    },
    {
        daas_id: '100567',
        metadata: {
            name: 'Sappy Seals',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/m2zTRB4ygMz4cOhGEkYJZ0f3kB9KdPcYa9Kn5uyZq1CX_1WgnB4SA_FDaMRn9CsSTS5RCFAjB83H6xtKYP_wy-7fvWtozobhyYtZ',
            description:
                'Sappy Seals is community-led project focused on metaverse expansion and a growing ecosystem\n\nPixl Labs Collections:\n[Pixl Pets](https://opensea.io/collection/pixl-pets-genesis) | \n[Digital Artifacts](https://opensea.io/collection/digital-artifacts-btc)\n\nHolder count is not accurate due to staking. An up to date count can be found at our website: https://sappyseals.io/\n\nSappy Seals offers: \n\n•The open world cross-community Pixlverse & Pixl Pets\n\n•Marketplace for exclusive metaverse items\n\n•Rarity-based staking for the PIXL utility token\n\nJoin them on their cool conquest by joining the Discord http://discord.gg/zy2dfyMKwE',
            external_url: 'https://sappyseals.io',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/tdwwXgqa8SpdrnJB4Ei-boejI79fo0TxtocbPhqcOUMf60_dBl7np2yjsXvngmaHCXlTbFQ3YdxFnQ4HsDALovMhKP3CO6tkV6Y=w2500',
        },
        slug: 'sappy-seals',
        floor_price_wei: '369800000000000000',
        reservoir_id: '0x364c828ee171616a39897688a831c2499ad972ec',
        spam_score: 0,
    },
    {
        daas_id: '105217',
        metadata: {
            name: 'SupDucks',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/M20nNk_jl771mtlDRkk9GEtEGyA4pkURQBKdQMLDII2qK_qXJrtyhzJEwbVp9Au4Om_KutmA9auEZAsUJ7rFJIVlxymlGBfeQg',
            description:
                'Cool duck says Sup! Launched July 17th, 2021 by **MegaVolt Corp.** SupDucks are a 10,000 randomly generated collection that grants you access to the SupDucks Ecosystem. \n\nEvery duck in the pond needs a friend so the DuckGod created KingFrogs and MegaToads, your Ducks BFFs! Each SupDuck doubles as a community pass to Discord, LiveStreams, IRL Events, $VOLT and gives each holder the opportunity to be a part of building the SupDucks MetaVerse.\n\nStay up to date: \n**\n[Twitter](https://twitter.com/realsupducks) |\n[Discord](https://discord.gg/supducks) |\n[Youtube](https://www.youtube.com/channel/UCa-nNLetADH7iGdvqzIIqSg)**\n\n[MegaVolt Collections](https://opensea.io/MegaVoltCorp?tab=created_collections)**',
            external_url: 'https://www.supducks.com/',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/-Xqqp1yyvTiyY2glvtE2UJIx2pGQJ55qmjbHvTfJ2j2YazEySefcTDGqGekv0SS0yB4CTUntWJrVhE4mpWfR20b_BMttYs6LpA=w2500',
        },
        slug: 'supducks',
        floor_price_wei: '66900000000000000',
        reservoir_id: '0x3fe1a4c1481c8351e91b64d5c398b159de07cbc5',
        spam_score: 0,
    },
    {
        daas_id: '110073',
        metadata: {
            name: 'SuperRare',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/yTCgeCavezIgeOPXJCUvciqXHWxkxmqivDBchf0_1U--BucG9l9S82yYJATLpnMfXR4HZUuKs4_0zZ63h2r__ZodqscXx-XEcGU',
            description:
                "SuperRare makes it easy to create, sell, and collect rare digital art. SuperRare's smart contract platform allows artists to release limited-edition digital artwork tracked on the blockchain, making the pieces rare, verified, and collectible. Filter the crypto art world's best selling works by artist name, creation type, and year of birth on OpenSea.",
            external_url: 'https://superrare.co',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/4HV_qyLfXL2eOLWhSKzOg8Vh6N_wQ-brLHRxz6aNOhP-yqUhsk9WIK6byoJL6fMvKQaDxB3kTJ8TaouK-Fga7uYQop62nXsbTgE=w2500',
        },
        slug: 'superrare',
        floor_price_wei: '23000000000000000',
        reservoir_id: '0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0',
        spam_score: 0,
    },
    {
        daas_id: '105537',
        metadata: {
            name: 'World of Women',
            image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/_HJOMZcoPpOOjRVnVX4eixlLMQA3FV-qcyvB2QI3HGLlJkY3qDQWVlAcTK5WfMy4cCbzAc5e6hJzw4sfMB-gE8HdcmFvW5UGBA',
            description:
                "World of Women is a collection of 10,000 NFTs that gives you full access to our network of artists, creators, entrepreneurs, and executives who are championing diversity and equal opportunity on the blockchain.\n\nCreated and illustrated by Yam Karkai (@ykarkai), World of Women has made prominent appearances at Christie's, The New Yorker and Billboard.\n\nJoin us to receive exclusive access to NFT drops, experiences, and much more.\n\nThe Time is WoW.",
            external_url: 'http://worldofwomen.art',
            banner_image_url:
                'https://m.y.at/mash/c_fit,w_500,q_fallback/https://lh3.googleusercontent.com/RwlSVo41dBWp3L_VFoVsNN9-cxoy0zWTb5YS7Ns1EyE38wqvfksS7mPCxHHWBfuPXD-2h_mlFZxG9TNF_FCnJsUu95XJoQwtwg=w2500',
        },
        slug: 'world-of-women-nft',
        floor_price_wei: '580000000000000000',
        reservoir_id: '0xe785e82358879f061bc3dcac6f0444462d4b5330',
        spam_score: 0,
    },
];
